import { financeKeys } from "@/modules/finances/gateway/financeKeys"
import { paymentsToValidateKeys } from "@/modules/finances/paymentsToValidate/gateway/paymentsToValidateKeys"
import { useServicesContext } from "@modules/core/services/services.context"
import { OutOfBandTransactionStatus } from "@modules/finances/boxPaymentAtCounter/entities/outOfBandTransactionType"
import { usePeriodParam } from "@modules/finances/hooks/usePeriod"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useOutOfBandTransactionActions = () => {
  const { boxFinanceApi } = useServicesContext()
  const queryClient = useQueryClient()
  const [period] = usePeriodParam()

  const validateOutOfBandTransactionMutation = useMutation({
    mutationFn: async ({ invoiceId, newStatus }: { invoiceId: string; newStatus: OutOfBandTransactionStatus }) => {
      return await boxFinanceApi.validateOutOfBandTransaction(invoiceId, newStatus)
    },
    onSuccess: async () => {
      // delay to allow the backend to update data from Stripe before invalidating queries
      await new Promise((resolve) => setTimeout(resolve, 1_000))

      // transactions lists
      await queryClient.invalidateQueries({ queryKey: financeKeys.all })
      await queryClient.invalidateQueries({ queryKey: paymentsToValidateKeys.all })

      // delay to allow the backend to update data from Stripe before invalidating queries
      await new Promise((resolve) => setTimeout(resolve, 2_000))

      await queryClient.invalidateQueries({ queryKey: ["boxStats", period] })
      await queryClient.invalidateQueries({ queryKey: ["boxLastUpdate"] })
    },
  })

  return {
    validateOutOfBandTransactionMutation,
  }
}
